// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:root {
  --bold-service-name: #444444;
  --session-remaining-color: #aaaaaa;
  --orders: #808080;
  --booking-duration: #6c6060;
}

.next-visit-selected_servicename {
  font-size: 14px;
  font-weight: 500;
  line-height: 16px;
  letter-spacing: 0em;
  text-align: left;
  color: var(--bold-service-name);
}

.next-visit_sessions-remaining {
  font-size: 10px;
  font-weight: 400;
  line-height: 12px;
  letter-spacing: 0em;
  text-align: left;
  color: var(--session-remaining-color);
}

.next-visit_order {
  font-family: Roboto;
  font-size: 12px;
  font-weight: 400;
  line-height: 18px;
  letter-spacing: 0em;
  text-align: left;
  color: var(--orders);
}

.next-visit_booking-duration {
  font-family: Roboto;
  font-size: 12px;
  font-weight: 400;
  line-height: 12px;
  letter-spacing: 0em;
  text-align: left;
}

.next-visit_total-price {
  font-family: Roboto;
  font-size: 14px;
  font-weight: 600;
  line-height: 16px;
  letter-spacing: 0em;
  text-align: left;
  color: black;
}

/* .appointment-completed {
  background: #f0f4f5;
} */

.appointment-completed {
  background-color: #f0f4f5;
  border-radius: 8px;
  padding: 13px 15px;
  height: 35px;
  width: 65px;
}

.completed-date {
  text-align: center;
  font-family: Poppins;
  font-size: 12px;
  font-style: normal;
  font-weight: 500;
  display: flex;
  justify-content: center;
  color: #b2bac5;
}

.completed-status {
  color: #b2bac5;
}

.appointment-upcoming {
  background-color: transparent;
  border-radius: 8px;
  /* padding: 13px 15px; */
  border: 0.5px solid #7f7f7f;
  height: 35px;
  width: 65px;
}

.upcoming-date {
  text-align: center;
  font-family: Poppins;
  font-size: 12px;
  font-style: normal;
  font-weight: 500;
  display: flex;
  justify-content: center;
  color: #666666;
}
.upcoming-next {
  text-align: center;
  font-family: Poppins;
  font-size: 10px;
  font-style: normal;
  font-weight: 500;
  display: flex;
  justify-content: center;
  color: #666666;
}
.upcoming-next-small {
  text-align: center;
  font-family: Poppins;
  font-size: 8px;
  font-style: normal;
  font-weight: 400;
  display: flex;
  justify-content: center;
  color: #666666;
}

.upcoming-text {
  font-size: 8.5px;
  color: #666666;
}
.upcoming-next-text {
  font-size: 8.5px;
  color: #ffff;
}

.book-new-session {
  /* padding: 13px 15px; */
  border: 1px solid #f1c40f;
  border-radius: 8px;
  background-color:transparent ;
  cursor: pointer;
  height: 35px;
  width: 65px;
}
.openbookingheading{
  color: #9A9A9A;
  font-size: 14px;
  font-weight: 400;
}
.openbookingheading span{
text-transform: capitalize;
}
.openbooking-servicename{
  color: #444444;
  font-size: 14px;
  font-weight: 500;
}
.openbooking-servicename span{
  color: #6C6060;
  font-size: 12px;
  font-weight: 400;
}
.appointment-details_attributes{
  color: #AAAAAA;
  font-size: 10px;
  font-weight: 400;
}
.openbooking-order{
  color: #808080;
  font-size: 12px;
  font-weight: 400 !important;
}
.appointment-time{
  color: #000000;
  font-size: 14px;
  font-weight: 600;
}
`, "",{"version":3,"sources":["webpack://./src/Calendar/scheduler/BookNextVisit/bookNextVisit.css"],"names":[],"mappings":"AAAA;EACE,4BAA4B;EAC5B,kCAAkC;EAClC,iBAAiB;EACjB,2BAA2B;AAC7B;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,mBAAmB;EACnB,gBAAgB;EAChB,+BAA+B;AACjC;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,mBAAmB;EACnB,gBAAgB;EAChB,qCAAqC;AACvC;;AAEA;EACE,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,mBAAmB;EACnB,gBAAgB;EAChB,oBAAoB;AACtB;;AAEA;EACE,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,mBAAmB;EACnB,gBAAgB;EAChB,YAAY;AACd;;AAEA;;GAEG;;AAEH;EACE,yBAAyB;EACzB,kBAAkB;EAClB,kBAAkB;EAClB,YAAY;EACZ,WAAW;AACb;;AAEA;EACE,kBAAkB;EAClB,oBAAoB;EACpB,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,aAAa;EACb,uBAAuB;EACvB,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,6BAA6B;EAC7B,kBAAkB;EAClB,wBAAwB;EACxB,2BAA2B;EAC3B,YAAY;EACZ,WAAW;AACb;;AAEA;EACE,kBAAkB;EAClB,oBAAoB;EACpB,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,aAAa;EACb,uBAAuB;EACvB,cAAc;AAChB;AACA;EACE,kBAAkB;EAClB,oBAAoB;EACpB,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,aAAa;EACb,uBAAuB;EACvB,cAAc;AAChB;AACA;EACE,kBAAkB;EAClB,oBAAoB;EACpB,cAAc;EACd,kBAAkB;EAClB,gBAAgB;EAChB,aAAa;EACb,uBAAuB;EACvB,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,cAAc;AAChB;AACA;EACE,gBAAgB;EAChB,YAAY;AACd;;AAEA;EACE,wBAAwB;EACxB,yBAAyB;EACzB,kBAAkB;EAClB,6BAA6B;EAC7B,eAAe;EACf,YAAY;EACZ,WAAW;AACb;AACA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;AAClB;AACA;AACA,0BAA0B;AAC1B;AACA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;AAClB;AACA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;AAClB;AACA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;AAClB;AACA;EACE,cAAc;EACd,eAAe;EACf,2BAA2B;AAC7B;AACA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;AAClB","sourcesContent":[":root {\n  --bold-service-name: #444444;\n  --session-remaining-color: #aaaaaa;\n  --orders: #808080;\n  --booking-duration: #6c6060;\n}\n\n.next-visit-selected_servicename {\n  font-size: 14px;\n  font-weight: 500;\n  line-height: 16px;\n  letter-spacing: 0em;\n  text-align: left;\n  color: var(--bold-service-name);\n}\n\n.next-visit_sessions-remaining {\n  font-size: 10px;\n  font-weight: 400;\n  line-height: 12px;\n  letter-spacing: 0em;\n  text-align: left;\n  color: var(--session-remaining-color);\n}\n\n.next-visit_order {\n  font-family: Roboto;\n  font-size: 12px;\n  font-weight: 400;\n  line-height: 18px;\n  letter-spacing: 0em;\n  text-align: left;\n  color: var(--orders);\n}\n\n.next-visit_booking-duration {\n  font-family: Roboto;\n  font-size: 12px;\n  font-weight: 400;\n  line-height: 12px;\n  letter-spacing: 0em;\n  text-align: left;\n}\n\n.next-visit_total-price {\n  font-family: Roboto;\n  font-size: 14px;\n  font-weight: 600;\n  line-height: 16px;\n  letter-spacing: 0em;\n  text-align: left;\n  color: black;\n}\n\n/* .appointment-completed {\n  background: #f0f4f5;\n} */\n\n.appointment-completed {\n  background-color: #f0f4f5;\n  border-radius: 8px;\n  padding: 13px 15px;\n  height: 35px;\n  width: 65px;\n}\n\n.completed-date {\n  text-align: center;\n  font-family: Poppins;\n  font-size: 12px;\n  font-style: normal;\n  font-weight: 500;\n  display: flex;\n  justify-content: center;\n  color: #b2bac5;\n}\n\n.completed-status {\n  color: #b2bac5;\n}\n\n.appointment-upcoming {\n  background-color: transparent;\n  border-radius: 8px;\n  /* padding: 13px 15px; */\n  border: 0.5px solid #7f7f7f;\n  height: 35px;\n  width: 65px;\n}\n\n.upcoming-date {\n  text-align: center;\n  font-family: Poppins;\n  font-size: 12px;\n  font-style: normal;\n  font-weight: 500;\n  display: flex;\n  justify-content: center;\n  color: #666666;\n}\n.upcoming-next {\n  text-align: center;\n  font-family: Poppins;\n  font-size: 10px;\n  font-style: normal;\n  font-weight: 500;\n  display: flex;\n  justify-content: center;\n  color: #666666;\n}\n.upcoming-next-small {\n  text-align: center;\n  font-family: Poppins;\n  font-size: 8px;\n  font-style: normal;\n  font-weight: 400;\n  display: flex;\n  justify-content: center;\n  color: #666666;\n}\n\n.upcoming-text {\n  font-size: 8.5px;\n  color: #666666;\n}\n.upcoming-next-text {\n  font-size: 8.5px;\n  color: #ffff;\n}\n\n.book-new-session {\n  /* padding: 13px 15px; */\n  border: 1px solid #f1c40f;\n  border-radius: 8px;\n  background-color:transparent ;\n  cursor: pointer;\n  height: 35px;\n  width: 65px;\n}\n.openbookingheading{\n  color: #9A9A9A;\n  font-size: 14px;\n  font-weight: 400;\n}\n.openbookingheading span{\ntext-transform: capitalize;\n}\n.openbooking-servicename{\n  color: #444444;\n  font-size: 14px;\n  font-weight: 500;\n}\n.openbooking-servicename span{\n  color: #6C6060;\n  font-size: 12px;\n  font-weight: 400;\n}\n.appointment-details_attributes{\n  color: #AAAAAA;\n  font-size: 10px;\n  font-weight: 400;\n}\n.openbooking-order{\n  color: #808080;\n  font-size: 12px;\n  font-weight: 400 !important;\n}\n.appointment-time{\n  color: #000000;\n  font-size: 14px;\n  font-weight: 600;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
